import React from 'react';
import { WebImage } from 'components/common/WebImage';
import { Avatar } from 'components/common/Avatar/';
import { Description } from './atoms/Description';
import { FormatTeams } from 'components/common/FormatTeams';
import { IconLinkGrid } from 'components/common/IconLinkGrid';
import { PersonWrapper } from './atoms/PersonWrapper';
import { TeamUser } from 'types/teamUser';
import { Title } from './atoms/Title';
import { Wrapper } from './atoms/Wrapper';
import { AvatarWrapper } from './atoms/AvatarWrapper';
import { NameWrapper } from './atoms/NameWrapper';

export interface LetsMeetCardProps {
    user: TeamUser;
    description: string;
}
export const LetsMeetCard: React.FC<LetsMeetCardProps> = ({ user, description }) => {
    const { fullname, imageAttachments, linkedInProfileUrl, phone, publicEmail } = user;

    return (
        <Wrapper>
            <Title>Let&apos;s meet!</Title>
            <PersonWrapper>
                <AvatarWrapper>
                    <Avatar size="50px">
                        <WebImage
                            image={{
                                alt: fullname,
                                ...imageAttachments[0].image,
                            }}
                        />
                    </Avatar>
                </AvatarWrapper>
                <NameWrapper>
                    {fullname} - <FormatTeams teams={user.teams} />
                </NameWrapper>
            </PersonWrapper>
            <Description>{description}</Description>
            <div>
                <IconLinkGrid meetUrl={linkedInProfileUrl} phone={phone} email={publicEmail} />
            </div>
        </Wrapper>
    );
};
